import './PeriscopeList.scss';
import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { NoData } from '@ui/NoData';
import { When } from 'react-if';
import React, { forwardRef } from 'react';

export interface PeriscopeListProps {
	list: (items: unknown[]) => React.ReactNode;
	loading: boolean;
	results: unknown[];
	striped?: boolean;
	title?: string;
}

export const PeriscopeList = forwardRef<HTMLDivElement, PeriscopeListProps>(({
	list,
	loading,
	results,
	striped,
	title
}, ref) => {
	const classes = classNames('periscope-paginated-list', { 'periscope-paginated-list-striped': striped });

	return (
		<>
			{ title && <div className='periscope-list-title'>{ title }</div> }
			<div
				className={ classes }
				ref={ ref }>
				<LoadingSpinner spinning={ loading }>
					<When condition={ !loading && results.length === 0 }>
						<NoData />
					</When>
					{ list(results) }
				</LoadingSpinner>
			</div>
		</>
	);
});
